const envConfig = {
    REACT_APP_REDIRECT_URL: "https://communityportal.devsuiteltts.com/dashboard/ui_repo",
    REACT_APP_CLIENT_ID: "8ae91ebc-1bf8-48a3-b0a0-926953f078cc",
    REACT_APP_AUTHORITY: "https://login.microsoftonline.com/311b3378-8e8a-4b5e-a33f-e80a3d8ba60a",
    REACT_APP_APIREPO_GATEWAY: "https://apihub-bk-gtway-shm-a6c9ayb4eqfwbpap.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_WRITE: "https://apihub-bk-pro-wr-ckadaybhhuambda9.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_READ: "https://apihub-bk-prod-rd-f8a8hzcjgkdeezcd.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_ADMIN: "https://apihub-admin-eddad0g9fdgaeyd6.southindia-01.azurewebsites.net",
    REACT_APP_APIREPO_LOGIN: "https://apihub-login-page-g4hxfcd3g2bnhkdm.southindia-01.azurewebsites.net",
    REACT_APP_UIREPO:"https://prod.appstudioltts.com"
};

export default envConfig;
